import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SubscriptionBanner() {
  const { isAuthenticated, user } = useAuth();

  const isCommunity     = isAuthenticated && user?.account_type === 'guest';
  const isUnauthenticated = !isAuthenticated;

  // Only show for unauthenticated visitors and community (free) accounts
  if (!isUnauthenticated && !isCommunity) return null;

  return (
    <div className="bg-blue-700 text-white px-4 py-3">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <svg className="w-5 h-5 text-blue-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>

          {isCommunity ? (
            <p className="text-sm">
              <span className="font-semibold">Community account — </span>
              upgrade for bed alerts, radius search, notes, and favorites.
            </p>
          ) : (
            <p className="text-sm">
              <span className="font-semibold">Guest access — </span>
              create a free account for full facility details, filters, and bed data.
            </p>
          )}
        </div>

        <div className="flex items-center gap-3 flex-shrink-0">
          {isUnauthenticated && (
            <Link
              to="/signup"
              className="text-sm text-blue-200 hover:text-white underline underline-offset-2 whitespace-nowrap"
            >
              Create free account
            </Link>
          )}
          <Link
            to="/subscribe"
            className="bg-white text-blue-700 hover:bg-blue-50 text-sm font-semibold px-4 py-1.5 rounded-lg whitespace-nowrap transition-colors"
          >
            View plans
          </Link>
        </div>
      </div>
    </div>
  );
}
